import BaseElement from './base_element';

export default class ImageElement extends BaseElement {
  constructor(managers, src, x, y, key = null, properties = {}) {
    super(managers, properties);
    this.key = key;
    this.element = this._createDomElement(src, x, y, properties);
    this._setupEvents();
  }

  _createDomElement(src, x, y, properties) {
    const element = document.createElement('div');
    element.className = 'canvas-element image-element';
    element.style.left = x + 'px';
    element.style.top = y + 'px';
    element.dataset.type = 'image';
    element.dataset.id = this.id;
    if (this.key) element.dataset.key = this.key;

    const img = document.createElement('img');
    img.src = src;
    img.style.width = properties.width || '200px';
    element.appendChild(img);

    const resizeHandle = document.createElement('div');
    resizeHandle.className = 'resize-handle';
    element.appendChild(resizeHandle);

    return element;
  }

  _setupEvents() {
    this.element.addEventListener('mousedown', (e) => {
      if (e.target.classList.contains('resize-handle')) {
        this.managers.resize.startResize(e, this.element);
      } else {
        this.managers.elementActions.handleSelectionAndDrag(e, this.element);
      }
    });
  }

  setWidth(width) {
    const img = this.element.querySelector('img');
    img.style.width = width;
  }

  getWidth() {
    const img = this.element.querySelector('img');
    return img.style.width;
  }

  getSrc() {
    const img = this.element.querySelector('img');
    return img.getAttribute('src');
  }

  getKey() {
    return this.key;
  }

  serialize() {
    const img = this.element.querySelector('img');
    return {
      ...this.getSerializeBase(),
      type: 'image',
      src: this.getSrc(),
      width: this.getWidth(),
      key: this.getKey()
    };
  }

  static fromData(data, managers) {
    return new ImageElement(
      managers,
      data.src,
      parseInt(data.left),
      parseInt(data.top),
      data.key,
      {
        id: data.id,
        width: data.width
      }
    );
  }
}
